/**
 * Created by Pali on 24/01/24.
 */

angular.module("screensApp").controller("QuickbetController", function ($scope, $rootScope) {
  // Show Quickbet Container
  $rootScope.showQuickbetContainer = function (data) {
    if (typeof data.token === "string") {
      $scope.qbURL = $rootScope.url.QuickbetVideoURL + "#/terminal/video?sessionToken=" + data.token + "&lang=" + (data.lang ? data.lang : "en");
      $rootScope.settings.quickbet.show = true;
      $rootScope.createLogForStreamMedia("QB", $rootScope.settings.quickbet.show);
      $rootScope.$$phase || $rootScope.$apply();
    }
  };

  // Hide Quickbet Container
  $rootScope.hideQuickbetContainer = function () {
    $scope.qbURL = getDefaultBannerRelativePath();
    $rootScope.settings.quickbet.show = false;
    $rootScope.createLogForStreamMedia("QB", $rootScope.settings.quickbet.show);
    $rootScope.$$phase || $rootScope.$apply();
  };

  // Cummunication with quickbet iframe
  $rootScope.quickbetVideoControl = function (data) {
    document.getElementById("quickBetVideoIframe").contentWindow.postMessage(data.data, $rootScope.url.QuickbetVideoURL);
  };
});
